module.exports = "/img/v2_qh7fef.61dbaa75.jpg";